import { observer } from 'mobx-react';
import { useStore } from '../../core/utils/hook';
import CourseListByStudent from './components/CourseListByStudent';

const CourseListByStudentScreen = observer(() => {

    // store
    const { groupAdminStore: { courseListByStudent } } = useStore();

    return(
        <div id='main' className='wrapper main-student-list main-view-student-detail main-content-home-2 pd-b-50'>
            <section className='content-student-list'>
                <div className='container w-full'>
                    <h1 className='title-primary mg-b-25'>受講者 #{courseListByStudent?.studentCode} 別の受講講座リスト</h1>
                    
                    <CourseListByStudent />
                </div>
            </section>
        </div>
    )
})

export default CourseListByStudentScreen;